import React, {Component} from 'react'
import {Link} from 'react-router-dom'

import style from './header.sass'

class Header extends Component {
  state = {
    width: 0,
    scrollY: 0,
    menu: false
  }
  componentDidMount() {
    this.getWidth()
    window.addEventListener('resize', this.getWidth)
    window.addEventListener('scroll', this.getPageYOffset)
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.getWidth)
    window.removeEventListener('scroll', this.getPageYOffset)
  }
  getPageYOffset = () => {
    const {scrollY} = window
    this.setState({scrollY})
  }
  getWidth = () => {
    const width = window.innerWidth
    this.setState({width})
  }
  toggleMenu = () => {
    const menu = !this.state.menu
    this.setState({menu})
  }
  scrollToAbout = () => {
    document.querySelector('#about').scrollIntoView({behavior:'smooth'})
  }
  render() {
    const {width, scrollY, menu} = this.state
    const menuVisible = menu || width > 1264
    return(
      <div styleName='wrapper'>
        <div styleName={scrollY < 80 ? 'container' : 'container-scroll'}>
          <header styleName='header'>
            <Link to='/' styleName='logo'><img src={'/img/logo-color.png'}/></Link>
            {width <= 1264 &&
              <button type='button' styleName='nav-toggle' onClick={this.toggleMenu}>
                <span className='sr'>Toggle navigation</span>
                <span styleName='bar'/>
                <span styleName='bar'/>
                <span styleName='bar'/>
              </button>
            }
            <nav styleName={menuVisible ? 'nav-expand' : 'nav'}>
              <ul>
                <li><Link to='/'>Home</Link></li>
                <li>
                  {this.props.about
                    ? <a onClick={this.scrollToAbout}>About Us</a>
                    : <Link to='/#about'>About Us</Link>
                  }
                </li>
                <li><Link to='/faq'>FAQ</Link></li>
                <li><Link to='/blog'>Blog</Link></li>
                <li><Link to='/careers'>Careers</Link></li>
                <li><Link to='/pricing'>Pricing</Link></li>
                <li><Link to='/contact'>Contact</Link></li>
                <li><Link to='/login' styleName='login'>Login</Link></li>
                <li><Link to='/pricing' styleName='signup'>Signup</Link></li>
              </ul>
            </nav>
          </header>
        </div>
      </div>
    )
  }
}

export default Header
